import styled from 'styled-components';
import {
  screenSize,
  whiteColor,
  regularFont,
  boldFont,
  primaryColor,
  primaryActiveColor,
  primaryHoverColor,
} from '@app/styles';

import municipalityLogoUrl from '@app/assets/images/Municipalitiesblack.svg';
import Logo from '@app/assets/images/munitechlogo.png';

type ImageProps = {
  image?: string;
  size?: string;
};

export const BackgroundContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const Container = styled.div`
  position: relative;
  padding: 0px 0px 16px 16px;
  width: 100%;
  height: calc(100vh - 147px);
  display: flex;
  margin: 147px auto 50px;
  box-shadow: rgb(55 76 99 / 0.2) 0px 6px 12px;
  flex-direction: column;
  background: ${whiteColor};
  overflow-x: hidden;
  overflow-y: auto;
  @media (${screenSize.tablet}) {
    padding: 0px 0px 50px 40px;
    width: calc(100vw - 100px);
    height: calc(100vh - 147px);
    display: flex;
    border-radius: 8px;
  }
`;
export const MunicipalityContainer = styled.div`
  @media (${screenSize.tablet}) {
    margin: 38px 0px 42px 0px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;
export const InfoBox = styled.div`
  margin-top: 20px;
  @media (${screenSize.tablet}) {
    margin-top: 0px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;
export const SecondaryInfoBox = styled.div`
  @media (${screenSize.tablet}) {
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const InfoCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    margin-top: 12px;
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
  }
`;
export const DetailsCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: flex-start;
  }
`;
export const DetailsBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    margin-top: 8px;
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
  }
`;
export const PrimaryDetailsBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    margin: 12px 0px 8px 0px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const InstCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    margin-top: 8px;
    width: 70%;
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    line-height: 24px;
  }
`;

export const PrimaryInfoBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PrimaryInfoCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    padding-top: 10px;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
  }
`;
export const InfoItem = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
    padding-right: 20px;
    width: 300px;
    margin: 0;
  }
`;
export const PrimaryInfoItem = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    margin: 0;
  }
`;
export const SecondaryInfoItem = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
    padding-right: 20px;
    width: 500px;
    margin: 0;
  }
`;
export const EmailInfoItem = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
    padding-right: 20px;
    width: 300px;
    margin: 0;
  }
`;

export const Heading = styled.div`
  font-size: 21px;
  color: rgb(33, 45, 58);
  line-height: 24px;
  font-family: Noto Serif;
  ${boldFont};
  margin-top: 16px;
  @media (${screenSize.tablet}) {
    margin-top: 0px;
  }
`;
export const PrimaryHeading = styled.div`
  font-size: 16px;
  color: rgb(33, 45, 58);
  line-height: 21px;
  ${boldFont};
`;

export const Label = styled.div`
  font-size: 15px;
  color: rgb(107, 111, 140);
  text-align: left;
  line-height: 30px;
  ${regularFont};
`;

export const LogoIcon = styled.div`
  font-size: 15px;
  margin-left: 12px;
  color: rgb(107, 111, 140);
  text-align: left;
  line-height: 30px;
  ${regularFont};
`;

export const Counties = styled.div`
  display: flex;
`;

export const Value = styled.div`
  font-size: 16px;
  color: rgb(4, 5, 6);
  line-height: 24px;
  ${regularFont};
  a {
    font-size: 16px;
    text-decoration: none;
    color: ${primaryColor};
    &:hover {
      color: ${primaryHoverColor};
    }
    &:active {
      color: ${primaryActiveColor};
    }
  }
`;

export const MunitechLogo = styled.div`
  width: 30px;
  height: 30px;
  position: absolute;
  margin-left: 10px;
  border-radius: 8px;
  margin-right: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url(${Logo});
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
export const LogoInfoCard = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  @media (${screenSize.tablet}) {
    margin-top: 12px;
  }
`;
export const IconItem = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`;
export const NumText = styled.div`
  font-size: 16px;
  color: #040506;
  opacity: 0.6;
  margin-top: 2px;
  padding-right: 5px;
`;
export const MultiInfoCard = styled.div`
  width: 100%;
  padding-bottom:20px;
  @media (${screenSize.tablet}) 
    display: flex;
  }
`;
export const Dollar = styled.div`
  font-size: 18px;
  color: #040506;
  padding-top: 2px;
`;

export const TaxRate = styled.div`
  @media (${screenSize.tablet}) {
    width: 40px;
    margin-right: 12px;
  }
`;
export const MunicipalityLogo = styled.div`
  min-width: 85px;
  min-height: 85px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f4f5f6;
`;
export const MuncipalityIcon = styled.div`
  background-position: center;
  background-size: cover;
  ${({ image }: ImageProps) => {
    if (image) {
      return `background-image:url(${image});
              width: 85px;
              height: 85px;
              border-radius:50%;
          `;
    } else {
      return `background-image: url(${municipalityLogoUrl});
      width: 40px;
      height: 40px;
      `;
    }
  }}
`;
